import React, { useId } from "react";

const KITS = {
  MUN: { body: "#DA291C", sleeve: "#DA291C", trim: "#ffffff" },
  ARS: { body: "#EF0107", sleeve: "#ffffff", trim: "#ffffff" },
  MCI: { body: "#6CABDD", sleeve: "#6CABDD", trim: "#ffffff" },
  LIV: { body: "#C8102E", sleeve: "#C8102E", trim: "#F6EB61" },
  CHE: { body: "#034694", sleeve: "#034694", trim: "#ffffff" },
  LEI: { body: "#0053A0", sleeve: "#0053A0", trim: "#FDBE11" },
  BLB: { body: "#0a84c4", alt: "#ffffff", sleeve: "#ffffff", trim: "#0a84c4", pattern: "halves" },
  TOT: { body: "#ffffff", sleeve: "#ffffff", trim: "#132257" },
  NEW: { body: "#111111", alt: "#ffffff", sleeve: "#111111", trim: "#ffffff", pattern: "stripes" },
  LEE: { body: "#ffffff", sleeve: "#ffffff", trim: "#1D428A" },
  EVE: { body: "#003399", sleeve: "#003399", trim: "#ffffff" },
  NFO: { body: "#e53233", sleeve: "#e53233", trim: "#ffffff" },
  WIM: { body: "#1560bd", sleeve: "#1560bd", trim: "#FDD000" },
  COV: { body: "#77B5E5", sleeve: "#77B5E5", trim: "#ffffff" },
  SUN: { body: "#d0021b", alt: "#ffffff", sleeve: "#111111", trim: "#111111", pattern: "stripes" },
  BOL: { body: "#ffffff", sleeve: "#ffffff", trim: "#1f3a6e" },
  BOR: { body: "#d81e29", sleeve: "#d81e29", trim: "#ffffff" },
  STK: { body: "#E03A3E", alt: "#ffffff", sleeve: "#E03A3E", trim: "#ffffff", pattern: "stripes" },
};

const GK_COLORS = ["#F5C400", "#22C55E", "#1F2937", "#FF7A00", "#A855F7", "#14B8A6"];

const gkKit = (short = "") => {
  const h = [...short].reduce((a, c) => a + c.charCodeAt(0), 0);
  const body = GK_COLORS[h % GK_COLORS.length];
  return { body, sleeve: body, trim: "#111111" };
};

export const kitFor = (short, color, isGK) => (isGK ? gkKit(short) : KITS[short] || { body: color, sleeve: color, trim: "#ffffff" });

export const BODY = "M20 6 L26 3.5 Q32 9 38 3.5 L44 6 L58 15 L53 27 L46 24 L46 59 L18 59 L18 24 L11 27 L6 15 Z";
export const LEFT_SLEEVE = "M20 6 L6 15 L11 27 L18 24 Z";
export const RIGHT_SLEEVE = "M44 6 L58 15 L53 27 L46 24 Z";

// FPL-style shirt drawn in SVG, coloured per club (no copyrighted crests).
export const ShirtKit = ({ short, color, isGK = false, empty = false, className = "w-12 h-12" }) => {
  const uid = useId().replace(/:/g, "");
  if (empty) {
    return (
      <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
        <path d={BODY} fill="currentColor" fillOpacity="0.18" stroke="currentColor" strokeOpacity="0.75" strokeWidth="1.6" strokeDasharray="3 2.5" />
      </svg>
    );
  }
  const kit = kitFor(short, color, isGK);
  return (
    <svg viewBox="0 0 64 64" className={`${className} drop-shadow-[0_4px_4px_rgba(0,0,0,0.35)]`} aria-hidden="true">
      <defs>
        <clipPath id={`c-${uid}`}>
          <path d={BODY} />
        </clipPath>
        <linearGradient id={`g-${uid}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#fff" stopOpacity="0.22" />
          <stop offset="0.55" stopColor="#fff" stopOpacity="0" />
          <stop offset="1" stopColor="#000" stopOpacity="0.25" />
        </linearGradient>
      </defs>
      <g clipPath={`url(#c-${uid})`}>
        <rect x="0" y="0" width="64" height="64" fill={kit.body} />
        {kit.pattern === "stripes" &&
          [22, 30, 38].map((x) => <rect key={x} x={x} y="0" width="4" height="64" fill={kit.alt} />)}
        {kit.pattern === "halves" && <rect x="32" y="0" width="32" height="64" fill={kit.alt} />}
        <path d={LEFT_SLEEVE} fill={kit.sleeve} />
        <path d={RIGHT_SLEEVE} fill={kit.sleeve} />
        <path d="M11 27 L6 15 L8 14 L13 26 Z M53 27 L58 15 L56 14 L51 26 Z" fill={kit.trim} />
        <rect x="0" y="0" width="64" height="64" fill={`url(#g-${uid})`} />
      </g>
      <path d="M26 3.5 Q32 9 38 3.5 L36 3 Q32 7 28 3 Z" fill={kit.trim} />
      <path d={BODY} fill="none" stroke="rgba(0,0,0,0.35)" strokeWidth="0.8" />
    </svg>
  );
};

export default ShirtKit;
